"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColorRotater = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _helpers = require("../../helpers");
var _templateObject;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Wrapper = _styledComponents["default"].span(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  border-radius: 5px;\n  width: 32px;\n  height: 32px;\n  padding: 6px 9px;\n  margin-right: 7px;\n  cursor: pointer;\n"])));
var ColorRotater = exports.ColorRotater = function ColorRotater(_ref) {
  var onChange = _ref.onChange,
    defaultValue = _ref.defaultValue;
  var onClick = function onClick() {
    setColor((0, _helpers.randomColor)());
  };
  var _useState = (0, _react.useState)(defaultValue || (0, _helpers.randomColor)()),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    backgroundColor = _useState2[0],
    setColor = _useState2[1];
  (0, _react.useEffect)(function () {
    onChange(backgroundColor);
  }, [backgroundColor]);
  return /*#__PURE__*/_react["default"].createElement(Wrapper, {
    onClick: onClick,
    title: "Rotate the color",
    style: {
      backgroundColor: backgroundColor
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    style: {
      color: (0, _helpers.getForegroundColorPerBackgroundContrast)(backgroundColor)
    },
    "data-testid": "labelPickerPlusIcon",
    id: "labelPicker",
    icon: _freeSolidSvgIcons.faSync
  }));
};